(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-back-view-override"] && !Shopify.designMode) return;
  try {
    
(() => {
  const swapBackView = () => {
    const image = document.querySelector('.bb-details-section .bb-detail-card:first-child .bb-detail-card-media img');
    if (image) {
      image.src = 'https://cdn.shopify.com/s/files/1/1026/9376/5399/files/bare-bones-back-view-enhanced.png?v=1788643621';
      image.alt = 'Back view of The Anatomy Crewneck';
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapBackView, { once: true });
  } else {
    swapBackView();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charisma-black-book"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-script-desk]').forEach(desk=>{const tabs=[...desk.querySelectorAll('[role="tab"]')];function activate(tab){tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!selected;});}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();activate(tabs[n]);tabs[n].focus();}});});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
